/**
 * What the member pays, in their own locale's format.
 *
 * Whole units in, because `gym_plans.price` is lei rather than bani. Only ever
 * the price: the platform fee and the gym's share are a matter between us and
 * the gym, and a member reading a breakdown would be left with a question only
 * the gym can answer.
 */
export function formatPrice(price: number, currency: string, locale: string): string {
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(price)
  } catch {
    // An unknown or empty currency code should still show the number.
    return `${price} ${currency}`.trim()
  }
}
